import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TYPE_MERCHANDISE_COORDINATION,
  TYPE_PLANNING_PRODUCING,
  TYPE_COPY,
  TYPE_TRANSLATION_CHINESE,
  TYPE_TRANSLATION_FRENCH,
  TYPE_TRANSLATION_JAPANESE,
  TYPE_COPY_PREP,
  TYPE_INVENTORY_PREP
} from '../../constants/booking';

import MerchandiseSheet from './LocationSheets/MerchandiseSheet';
import PlanningSheet from './LocationSheets/PlanningSheet';
import { renderSheets } from './CallsheetUtils';
import CallsheetHeader from './CallsheetHeader';
import GeneralLocationSheet from './LocationSheets/GeneralLocationSheet';
import { naturalSortKeys } from '../../helpers/callSheetHelpers';

import i18n from '../../i18n';

class ContentLocalizationCallsheet extends Component {
  render() {
    const { bookings, date, renderForEmail, locationContacts } = this.props;

    let locationSheets = [];

    Object.entries(bookings).forEach(locationTypeEntry => {
      const [locationTypeIdString, locations] = locationTypeEntry;
      const locationTypeId = parseInt(locationTypeIdString, 10);

      const filteredLocationContacts = locationContacts ? locationContacts[locationTypeId] : i18n.t('noData');

      switch (locationTypeId) {
        case TYPE_INVENTORY_PREP:
        case TYPE_COPY:
        case TYPE_COPY_PREP:
        case TYPE_TRANSLATION_CHINESE:
        case TYPE_TRANSLATION_FRENCH:
        case TYPE_TRANSLATION_JAPANESE:
          locationSheets = locationSheets.concat(
            renderSheets(GeneralLocationSheet, locations, renderForEmail, filteredLocationContacts)
          );
          break;
        case TYPE_MERCHANDISE_COORDINATION:
          locationSheets = locationSheets.concat(
            renderSheets(MerchandiseSheet, locations, renderForEmail, locationContacts)
          );
          break;
        case TYPE_PLANNING_PRODUCING:
          locationSheets = locationSheets.concat(
            renderSheets(PlanningSheet, locations, renderForEmail, locationContacts)
          );
          break;
        default:
          // Skip over location types that don't pertain to this callsheet
          break;
      }
    });

    return (
      <>
        <CallsheetHeader date={date} renderForEmail={renderForEmail} />
        {locationSheets.sort(naturalSortKeys)}
      </>
    );
  }
}

ContentLocalizationCallsheet.propTypes = {
  bookings: PropTypes.objectOf(PropTypes.objectOf(PropTypes.object)).isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  locationContacts: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  ).isRequired,
  renderForEmail: PropTypes.bool.isRequired
};

export default ContentLocalizationCallsheet;
